import { useState, useEffect, useCallback as _useCallback } from 'react'
import { Loader2 } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { api } from '@services/enhancedApiService'
import { useWebSocketContext } from '@contexts/WebSocketContext'

/**
 * Shows a pulsing indicator in the header when backtests are running.
 * Initial count from REST, live updates via WebSocket.
 */
export default function RunningBacktests() {
  const [count, setCount] = useState(0)
  const navigate = useNavigate()
  const ws = useWebSocketContext()

  // Initial REST fetch for current running count
  useEffect(() => {
    api
      .get('/trading/backtests?status=running')
      .then(({ data }) => {
        if (data.success) setCount(data.data?.count || 0)
      })
      .catch(() => {})
  }, [])

  // Live updates via WebSocket
  useEffect(() => {
    if (!ws.isAuthenticated) return
    ws.subscribe(['backtests'])
    const unsubStarted = ws.on('backtest.started', () => setCount(c => c + 1))
    const unsubCompleted = ws.on('backtest.completed', () =>
      setCount(c => Math.max(0, c - 1))
    )
    const unsubFailed = ws.on('backtest.failed', () =>
      setCount(c => Math.max(0, c - 1))
    )
    return () => {
      ws.unsubscribe(['backtests'])
      unsubStarted()
      unsubCompleted()
      unsubFailed()
    }
  }, [ws])

  if (count === 0) return null

  return (
    <button
      onClick={() => navigate('/backtests')}
      title={`${count} backtest${count > 1 ? 's' : ''} running`}
      className="flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium rounded-full bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300 hover:bg-amber-200 dark:hover:bg-amber-900/50 transition-colors"
    >
      <Loader2 className="w-3.5 h-3.5 animate-spin" />
      {count} running
    </button>
  )
}
